import { render, staticRenderFns } from "./InclusionRisk.vue?vue&type=template&id=58c56918&scoped=true&"
import script from "./InclusionRisk.vue?vue&type=script&lang=js&"
export * from "./InclusionRisk.vue?vue&type=script&lang=js&"
import style0 from "./InclusionRisk.vue?vue&type=style&index=0&id=58c56918&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c56918",
  null
  
)

export default component.exports